module.exports = __webpack_public_path__ + "media/images/help-center-f48c42d626c18a46b96943fbab518c78.png";